module.exports = __webpack_public_path__ + "assets/img/profile-goals-active-old.ae6cf3eb.svg";